





styles += """

  [data-widget="LandingPage"] .demo_header_wrapper {
    margin: auto;
    position: relative;
  }

  [data-widget="LandingPage"] .inspiring_text {
    color: white;
    max-width: 1050px;
    margin: auto;
    padding: 30px 24px 64px 24px;
  }

  [data-widget="LandingPage"] .considerit_creates, [data-widget="LandingPage"] .visual_summaries {
    font-weight: 400;
    color: white;
    font-size: #{responsive_css_rule({min_size: 16, max_size: 28, min_vw: 605, max_vw: 1000})};
  }

  [data-widget="LandingPage"] .inspiring_text .main_callout {
    text-align: left;
    text-transform: uppercase;
    font-size: #{responsive_css_rule({min_size: 24, max_size: 44, min_vw: 548, max_vw: 879})};    
  }

  [data-widget="LandingPage"] .visual_summaries {
    text-align: right;
  }


  @media (max-width: 370px) {
    [data-widget="LandingPage"] .curious_block a {
      font-size: 15px;
      padding: 8px 8px;
    }
  }

  @media (max-width: 652px) {
    [data-widget="LandingPage"] .inspiring_text {
      padding: 30px 24px;
    }
    [data-widget="LandingPage"] .considerit_creates {
      display: none;
    }
    [data-widget="LandingPage"] .inspiring_text .main_callout, [data-widget="LandingPage"] .visual_summaries {
      text-align: center;
    }
  }

  @media (min-width: 653px) {
    [data-widget="LandingPage"] .demo_header_wrapper {
      padding-top: 32px;
    }
    [data-widget="LandingPage"] .inspiring_text .main_callout {
      margin-left: 48px;
    }
    [data-widget="LandingPage"] .considerit_creates, [data-widget="LandingPage"] .visual_summaries {
      font-style: italic;
    }

  }


  @media (max-width: 878px) {

    [data-widget="LandingPage"] .curious_block a {
      display: block;
      text-transform: capitalize;
    }
    [data-widget="LandingPage"] .curious_separator {
      display: none;
    }

  }

  @media (min-width: 652px) and (max-width: 1250px) {
    [data-widget="LandingPage"] .considerit_creates, [data-widget="LandingPage"] .visual_summaries {
      margin: 0 24px;
    }
  }

[data-widget="LandingPage"] .sub_value_prop {
  font-size: 16px;
  margin: 0px auto 48px auto;
  text-align: center;
  padding: 0 24px;
} @media (max-width: 673px) [data-widget="LandingPage"] .sub_value_prop {
  margin-bottom: 8px;
}

"""

window.LandingPage = ReactiveComponent
  displayName: 'LandingPage'

  render: -> 
    loc = fetch 'location'

    w = SAAS_PAGE_WIDTH()

    DIV 
      style: 
        color: 'white'        

      DIV 
        className: 'demo_header_wrapper'
        DIV 
          className: 'inspiring_text'

          H1 
            className: 'condensed'

            DIV 
              className: 'considerit_creates'

              'Consider.it creates '

            DIV
              className: 'main_callout'
                
              if w < 327
                'Civil & focused dialogue'
              else if w < 1016
                'Civil and focused dialogue'
              else 
                "CIVIL, ORGANIZED, AND FOCUSED ONLINE DIALOGUE"

            DIV 
              className: 'visual_summaries'

              if w < 605
                ' Visual summaries of what your community thinks, and why.'
              else 
                ' by visually summarizing what your community thinks and why'



        DIV 
          style: 
            textAlign: 'center'
            position: 'relative'
            zIndex: 1
            top: 8
            width: "var(--SAAS_PAGE_WIDTH)"
            margin: 'auto'

          Demo
            width: '100%'
            src: 'overall-small-x264.mp4'
            href: 'https://seattle2035-key-changes.consider.it'
            alt: "The City of Seattle is one of many to trust Consider.it with their community engagement needs."

        DIV
          dangerouslySetInnerHTML: __html: """
            <style>
              .custom-shape-divider-bottom-1648926759 {
                  position: absolute;
                  bottom: 50px;
                  left: 0;
                  width: 100%;
                  overflow: hidden;
                  line-height: 0;
                  transform: rotate(180deg);
              }

              .custom-shape-divider-bottom-1648926759 svg {
                  position: relative;
                  display: block;
                  width: calc(131% + 1.3px);
                  height: 243px;
                  max-height: 243px;
              }
              @media (max-width: 999px) {
                .custom-shape-divider-bottom-1648926759 svg {
                  height: calc(100vw / 1000 * 243);
                }
              }

              .custom-shape-divider-bottom-1648926759 .shape-fill {
                  fill: #FFFFFF;
              }

            </style>
            <div class="custom-shape-divider-bottom-1648926759">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" class="shape-fill"></path>
                    <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" class="shape-fill"></path>
                    <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" class="shape-fill"></path>
                </svg>
            </div>



          """          




      DIV 
        style: 
          backgroundColor: 'white'
          color: 'black'
          position: 'relative'
          paddingTop: 50
          paddingBottom: 50
          marginTop: -50

      
        ConversionAttempt
          backgroundColor: '#dc5f60'



        DIV 
          className: "sub_value_prop"

          # """Dialogues with integrity. Include, learn, align, and move together."""

          # """Civil and focused community engagement, even
          #    when hundreds participate. You can learn together, get on
          #    the same page, make inclusive decisions, and gain buy-in."""

          # """Community engagement with integrity, even
          #    when hundreds participate. You can learn together, get on
          #    the same page, make inclusive decisions, and gain buy-in."""

          # """A forum that makes the integrity of your community engagement visible, even
          #    when hundreds participate. Learn together, get on
          #    the same page, make inclusive decisions, and gain buy-in."""

          # """An opinion slate for your community. Learn together, get on
          #    the same page, make inclusive decisions, and gain buy-in. 
          #    Make the integrity of your community engagement visible."""

          # """Consider.it conversations stay focused — even if hundreds participate — so you can learn together, 
          #    make better decisions, and gain buy-in, without expensive meetings or 
          #    overwhelming comment threads."""

          H2
            className: 'light_callout'

            DIV null,
              "Engage your Community "

            DIV 
              style: 
                fontSize: 18
                fontWeight: 400

              "Hear diverse voices, learn together, and gain buy-in."


          #   # """An opinion slate for your community"""
          # "A transparent account of your community's opinions helps to bring integrity to your community engagement."

          # "A transparent account of your community's opinions helps make your community engagement whole."
          # "A transparent account of your community's opinions."
          # "Make your engagement whole with a transparent account of your community's opinions."

          # # """Learn together, get on
          # #    the same page, make inclusive decisions, and gain buy-in. 
          # #    Make the integrity of your community engagement visible."""
          # "Hear diverse voices, learn together, and gain buy-in."


        DIV 
          style: 
            position: 'relative'
            zIndex: 2
            paddingBottom: 70
            color: 'black'


          TestimonialGrid 
            testimonials: [testimonials.kehau, testimonials.susie, testimonials.russ]



        UseCases()

        DIV 
          style: 
            # maxWidth: 660
            fontSize: 16
            margin: '56px auto 0px auto'
            textAlign: 'center'
            padding: "0 12px"

          H2
            className: 'light_callout'

            "Want to start an engagement? "

            DIV 
              style: 
                fontSize: 16
                fontWeight: 400
              "It only takes a minute to create a forum and start a conversation."


        ConversionAttempt
          pages: ['create_forum', 'pricing']



        DIV 
          className: 'curious_block'
          style: 
            textAlign: 'center'
            fontSize: 18
            padding: '0 24px'
          "Curious about something else? "

          BR null

          A
            href: conversion_pages().tour.url
            style:
              color: '#9e4444'
            "Learn more about the product"


          SPAN 
            className: 'curious_separator'
            dangerouslySetInnerHTML: __html: ",&nbsp;&nbsp;&nbsp;"


          A
            href: conversion_pages().demo.url
            target: '_blank'
            style:
              color: '#9e4444'
            "play with a demo forum"

          SPAN 
            className: 'curious_separator'          
            dangerouslySetInnerHTML: __html: ",&nbsp;&nbsp;&nbsp;"

          A
            href: conversion_pages().examples.url
            style:
              color: '#9e4444'
            "browse cases"

          SPAN 
            dangerouslySetInnerHTML: __html: ",&nbsp;&nbsp;&nbsp;"
            className: 'curious_separator'
          A
            href: conversion_pages().about_us.url
            target: '_blank'
            style:
              color: '#9e4444'

            "about us"

          SPAN 
            dangerouslySetInnerHTML: __html: ",&nbsp;&nbsp; or&nbsp;&nbsp;"
            className: 'curious_separator'
          A
            href: conversion_pages().contact.url
            target: '_blank'
            style:
              color: '#9e4444'

            "contact us"

          SPAN 
            className: 'curious_separator'          
            "."


        




nav = [

  {
    label: 'How does it work?'
    link: '/tour'
    links: [
      {
        label: 'Starting your own forum'
        link: '/tour'
      }, 
      {
        label: 'features'
        link: '/tour#features'
      }, 
      {
        label: 'research findings'
        link: '/tour#research'
      }
    ]
  }, 

  {
    label: 'Show me cases!'
    link: '/examples'
    links: [
      {
        label: 'Strategic planning on a tight budget'
        link: '/examples/strategic_planning'
      }, 
      {
        label: 'civil public engagement'
        link: '/examples/public_engagement'
      }, 
      {
        label: 'decentralized community decision-making'
        link: '/examples/decentralized_decisions'
      }, 
    ]
  }, {
    label: 'What will it cost?'
    link: '/pricing'
    links: [
      {
        label: 'Free and Customized tiers'
        link: '/pricing'
      }, 
      {
        label: 'consulting services'
        link: '/pricing#consulting'
      }, 
      {
        label: 'FAQ'
        link: '/pricing#faq'
      }
    ]
  },

  {
    label: 'I\'d like to talk'
    link: '/contact'
    links: [
      {
        label: 'Request a demo'
        link: '/contact?form=request_demo'
      },       
      {
        label: 'general inquiry'
        link: '/contact'
      }
    ]
  }
]

section_div = (section) -> 
  DIV null,
    H3 
      className: 'main_callout'        
      style: 
        paddingBottom: 10
        color: 'black'
        textShadow: 'none'
      A 
        href: section.link
        className: 'condensed'
        style: 
          textDecoration: 'underline' 

        section.label 

    UL 
      style: 
        listStyle: 'none'
        

      for link, idx in section.links
        LI 
          style:
            textAlign: 'center'
            opacity: .7
            display: 'inline'
          A 
            href: link.link
            style: 
              textDecoration: 'underline'
              fontSize: 18
              fontWeight: 400
              # color: 'white'

            link.label
          if idx < section.links.length - 1
            ', '


styles += """
  [data-widget="Demo"] .salient_video_controls {
    position: absolute;
    right: 6px;
    top: 6px;
    background-color: #534B4B;
    opacity: .7;
    padding: 0px 12px;
    border-radius: 8px;
    font-size: 24px;
  }

  @media (max-width: 780px) {
    [data-widget="Demo"] .salient_video_controls {
      display: none;
    }
  }

"""

window.Demo = ReactiveComponent
  displayName: 'Demo'

  render: -> 
    if !@local.playing?
      @local.playing = true 

    loc = fetch('location')
    props = @props
    watch_demo = -> 
      window.scrollTo(0,0)    
      loc.query_params.play_demo = true 
      save loc 
        
    DIV 
      style:
        position: 'relative'
        # width: props.width
        # margin: 'auto'
        #cursor: 'pointer'

      
      Webframe
        browser_loc: @props.href
        width: "calc(props.width + 2px)"
        dummy: props.width
        dummy2: @local.playing

        DIV 
          style: 
            width: '100%'
            margin: 'auto'
            position: 'relative'

          VIDEO
            ref: 'video'
            preload: 'true'
            loop: true
            autoPlay: true
            muted: true
            controls: true
            title: @props.alt
            style: 
              aspectRatio: "21/9"
              width: props.width
              display: 'block'

            SOURCE
              key: 'mp4'
              src: asset("product_page/screencasts/#{@props.src}") 
              type: "video/mp4"

            @props.alt or "Your browser does not support the video element."

          DIV 
            className: "salient_video_controls"

            BUTTON 
              style: 
                cursor: 'pointer'
                backgroundColor: 'transparent'
                border: 'none'
                color: 'white'
                width: 33
                display: 'inline-block'
              title: if @local.playing then 'Pause video demo' else 'Play video demo'
              onClick: => 
                @toggleVideoPlay()
              onKeyPress: (e) => 
                if e.which == 32 || e.which == 13
                  @toggleVideoPlay()

              if !@local.playing 
                SPAN 
                  dangerouslySetInnerHTML: 
                    __html: '&#9658;'
              else 

                [SPAN 
                  key: 'first'
                  dangerouslySetInnerHTML: 
                    __html: '&#10073'
                SPAN 
                  key: 'second'
                  style: 
                    paddingLeft: 1
                  dangerouslySetInnerHTML: 
                    __html: '&#10073'
                ]

            BUTTON 
              style: 
                color: 'white'
                marginLeft: 6
                display: 'inline-block'
                cursor: 'pointer'
                backgroundColor: 'transparent'
                border: 'none'
                fontSize: 40
                lineHeight: '18px'
                position: 'relative'
                top: 1
              title: 'Restart video demo'
              onClick: => 
                @restart()
              onKeyPress: (e) => 
                if e.which == 32 || e.which == 13
                  @restart()

              dangerouslySetInnerHTML: 
                __html: '&#10226;'

  
  toggleVideoPlay: -> 
    el = @refs.video

    if @local.playing 
      el.pause?()
    else 
      el.play?()

    @local.playing = !@local.playing
    save @local 

    document.activeElement.blur()

  restart: -> 
    el = @refs.video
    el.currentTime = 0
    document.activeElement.blur()


  componentDidMount: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@)
  componentDidUpdate: ->
    play_videos_when_in_viewport ReactDOM.findDOMNode(@)



window.Webframe = ReactiveComponent
  displayName: 'Webframe'

  render: -> 

    width = @props.width or 882

    DIV 
      style: 
        backgroundColor: 'white'
        borderRadius: 4
        boxShadow: '0 2px 8px rgba(0,0,0,.1)'
        border: '1px solid #DADADA'
        borderTop: 'none'
        width: width
        margin: 'auto'

      SVG 
        viewBox: "0 0 882 26"
        style: 
          borderRadius: '4px 4px 0 0'
          position: 'relative'
          top: -1
          display: 'block'


        dangerouslySetInnerHTML: {__html: """
          <defs>
              <linearGradient x1="50%" y1="0%" x2="50%" y2="97.915338%" id="linearGradient-1">
                  <stop stop-color="#F6F4F6" offset="0%"></stop>
                  <stop stop-color="#D5D5D5" offset="99.5416135%"></stop>
                  <stop stop-color="#B7B6B7" offset="100%"></stop>
              </linearGradient>
              <rect id="path-2" x="0" y="0" width="882" height="25" rx="0"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-3">
                  <feOffset dx="0" dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-4">
                  <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
                  <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-5" x="0" y="0" width="361.581259" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-6">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-7">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-8" x="0" y="0.606608157" width="16.4648609" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-9">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-10">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-11" x="0" y="0.606608157" width="17.1105417" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-12">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-13">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <ellipse id="path-14" cx="29.7013177" cy="4.45706419" rx="3.87408492" ry="3.87196696"></ellipse>
              <mask id="mask-15" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.74393392" fill="white">
                  <use xlink:href="#path-14"></use>
              </mask>
              <ellipse id="path-16" cx="16.7877013" cy="4.43125108" rx="3.87408492" ry="3.84615385"></ellipse>
              <mask id="mask-17" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.69230769" fill="white">
                  <use xlink:href="#path-16"></use>
              </mask>
              <ellipse id="path-18" cx="3.87408492" cy="4.43125108" rx="3.87408492" ry="3.84615385"></ellipse>
              <mask id="mask-19" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.69230769" fill="white">
                  <use xlink:href="#path-18"></use>
              </mask>
          </defs>
          <g id="landing-page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Desktop-HD-Copy-34" transform="translate(-328.000000, -749.000000)">
                  <g id="Safari" transform="translate(328.000000, 750.000000)">
                      <g id="background">
                          <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-2"></use>
                          <use fill-opacity="0.6" fill="url(#linearGradient-1)" fill-rule="evenodd" xlink:href="#path-2"></use>
                          <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-2"></use>
                      </g>
                      <!-- 
                      <g id="New-Tab" transform="translate(866.503660, 8.974359)">
                          <rect id="background" fill-opacity="0.5" fill="#B6B6B6" x="0" y="0" width="15.4963397" height="16.025641"></rect>
                          <path d="M7.74816984,7.69230769 L4.51976574,7.69230769 L4.51976574,8.33763552 L7.74816984,8.33763552 L7.74816984,11.5857856 L8.39385066,11.5857856 L8.39385066,8.33763552 L11.6222548,8.33763552 L11.6222548,7.69230769 L8.39385066,7.69230769 L8.39385066,4.48717949 L7.74816984,4.48717949 L7.74816984,7.69230769 Z M0.64568082,0 L15.4963397,0 L15.4963397,0.645327827 L0.64568082,0.645327827 L0.64568082,0 Z M0,0 L0.64568082,0 L0.64568082,15.376011 L0,15.376011 L0,0 Z" id="Add" fill="#7D7D7D"></path>
                      </g>
                      -->


                      <g id="Search" transform="translate(260.209370, 5.162623)" style="#{if @props.browser_loc?.length > 0 then '' else 'display:none'}">
                          <g id="background">
                              <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-5"></use>
                              <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-5"></use>
                              <use fill="black" fill-opacity="1" filter="url(#filter-7)" xlink:href="#path-5"></use>
                          </g>
                          <path d="M352.865451,3.86914807 C351.055024,4.03175239 349.636164,5.55230111 349.636164,7.40406126 C349.636164,9.36428721 351.22611,10.9533643 353.187408,10.9533643 C355.148707,10.9533643 356.738653,9.36428721 356.738653,7.40406126 C356.738653,7.29529458 356.733758,7.18767059 356.724176,7.08139735 L356.075239,7.08139735 C356.086957,7.18733884 356.092972,7.29499793 356.092972,7.40406126 C356.092972,9.00788249 354.792107,10.3080365 353.187408,10.3080365 C351.58271,10.3080365 350.281845,9.00788249 350.281845,7.40406126 C350.281845,5.90900072 351.41226,4.67781842 352.865451,4.51771221 L352.865451,5.79162418 L356.09209,4.17742213 L352.865451,2.56322008 L352.865451,3.86914807 Z" id="reload" fill="#7E7E7E"></path>
                          <text id="url" font-family="HelveticaNeue, Helvetica Neue" font-size="10" font-weight="normal" letter-spacing="-0.15384616" fill="#000000">
                              <tspan x="19.6134701" y="10.5641026">#{@props.browser_loc}</tspan>
                          </text>
                      </g>
                      <g id="Back-+-Forward" transform="translate(50.363104, 4.521597)">
                          <g id="forward" transform="translate(17.756223, 0.000000)">
                              <g id="background">
                                  <use fill="black" fill-opacity="1" filter="url(#filter-9)" xlink:href="#path-8"></use>
                                  <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-8"></use>
                                  <use fill="black" fill-opacity="1" filter="url(#filter-10)" xlink:href="#path-8"></use>
                              </g>
                              <g id="Icon" transform="translate(6.779649, 4.190329)" stroke="#DADADA" stroke-width="1.5" stroke-linecap="round">
                                  <path d="M0.161420205,0.161331957 L3.425862,3.42398908" id="Line"></path>
                                  <path d="M0.161420205,6.69625979 L3.425862,3.43360266" id="Line"></path>
                              </g>
                          </g>
                          <g id="back">
                              <g id="background">
                                  <use fill="black" fill-opacity="1" filter="url(#filter-12)" xlink:href="#path-11"></use>
                                  <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-11"></use>
                                  <use fill="black" fill-opacity="1" filter="url(#filter-13)" xlink:href="#path-11"></use>
                              </g>
                              <g id="Icon" transform="translate(7.685212, 7.690329) scale(-1, 1) translate(-7.685212, -7.690329) translate(5.685212, 4.190329)" stroke="#585858" stroke-width="1.5" stroke-linecap="round">
                                  <path d="M0.161420205,0.161331957 L3.425862,3.42398908" id="Line"></path>
                                  <path d="M0.161420205,6.69625979 L3.425862,3.43360266" id="Line"></path>
                              </g>
                          </g>
                      </g>
                      <g id="Close-+-Minimize-+-Full-Screen" transform="translate(8.393851, 7.748236)">
                          <use id="green" stroke="#19B228" mask="url(#mask-15)" fill="#14CA34" xlink:href="#path-14"></use>
                          <use id="yellow" stroke="#E3A300" mask="url(#mask-17)" fill="#FFC008" xlink:href="#path-16"></use>
                          <use id="red" stroke="#E4453A" mask="url(#mask-19)" fill="#FF5F52" xlink:href="#path-18"></use>
                      </g>
                  </g>
              </g>
          </g>
          """}

      @props.children 








use_cases = [
  {
    title: 'Engaging the public '
    subtitle: 'to get focused feedback on proposals'
    examples: [
      {
        img: 'logos/denver.svg'
        example: 'https://denverclimateaction.consider.it'
        img_dim: {height: 62, width: 217}
        color: '#C51100'
        # adj: {left: 20}  
        anchor: "Input on Climate Action Plan"
        alt: "The City of Denver uses Consider.it to get public feedback on their Climate Action Plan."         
      }

      {
        img: 'logos/seattle-full.svg'
        example: 'https://hala.consider.it'
        img_dim: {height: 43, width: 230}
        color: '#007BC6'
        # adj: {top: -4}   
        anchor: "Housing Affordability dialogue"         
        alt: "The City of Seattle uses Consider.it to get public feedback on policies related to housing affordability."         

      }


      {
        img: 'logos/kauai.svg'
        example: 'https://oedinnovationgrant.consider.it'
        img_dim: {height: 55, width: 231}
        color: '#46315b'
        # adj: {top: -4}   
        anchor: "Innovation grant participatory budgeting"
        alt: 'The Island of Kauai does participatory budgeting for its Innovation Grant challenge.'
      }

      {
        img: 'logos/cambridge.png'
        example: 'https://envisioncambridge.consider.it'
        img_dim: {height: 59, width: 175}
        color: '#000000'
        # adj: {top: -4}   
        anchor: "Comprehensive Plan update"
        alt: 'The City of Cambridge, Massachusetts engages the public on its comprehensive plan update.'
      }
    ]
  }
  {
    title: 'Community ideation '
    subtitle: 'to tap the creativity of your community'
    examples: [
      {
        img: 'logos/mozilla.svg'
        example: 'https://internethealthreport.consider.it'   
        img_dim: {height: 49, width: 171}     
        # adj: {top: -4}   
        color: '#000'
        anchor: "Community ideation about how to measure internet health"
        alt: "The Mozilla Foundation engages its community about what it should measure to evaluate the health of the internet."

      }
      {
        img: 'logos/aina.png'
        example: 'https://ainaalohafutures.consider.it/'
        img_dim: {height: 51, width: 231}
        color: '#2A4C7E'
        # adj: {left: 14}   
        anchor: "Towards a regenerative economic plan for Hawai’i" # "Dialogue in advance of a regenerative economic development summit"
        alt: "Helping a native-led community effort to put forward a vision of a regenerative Hawai’i."
      }

      {
        img: 'logos/dao.svg'
        example: 'https://dao.consider.it'
        img_dim: {height: 56, width: 183}
        color: '#D1170B'
        # adj: {top: -4, left: 20}   
        anchor: "Open source cryptocurrency community governance"
        alt: "Helping a large decentralized cryptocurrency project deliberate about proposals."

      }

      {
        img: 'logos/beeminder.png'
        example: 'https://beeminder.consider.it'
        img_dim: {height: 56, width: 206}
        color: '#3a3a3c'
        anchor: "Community-informed product direction"
        alt: "Consider.it is being used by Beeminder to engage its community about development priorities."
      }

    ]
  }

  {
    title: 'Align on a new strategy '
    subtitle: 'by engaging relevant stakeholders'
    examples: [
      {
        img: 'logos/wadems.png'
        example: 'https://newblueplan.consider.it'   
        img_dim: {height: 47, width: 233}     
        color: '#0D4975'
        # adj: {top: -4}   
        anchor: "Participatory strategic planning"
        alt: "The Democratic Party of Washington State uses Consider.it to help engage in participatory strategic planning."
      }
      {
        img: 'logos/mozilla.svg'
        example: 'https://mofo-impact-goal.consider.it'   
        img_dim: {height: 49, width: 171}     
        color: '#000'
        # adj: {top: -4}   
        anchor: "Feedback on candidate impact statements to underpin a new strategy"
        alt: "The Mozilla Foundation uses Consider.it to engage its community about the pillars of a strategic plan."
      }

      {
        img: 'logos/wsffn.svg'
        example: 'https://wsffn.consider.it'   
        img_dim: {height: 74, width: 232}     
        color: '#6C7C00'
        anchor: "Stakeholder engagement (board, donors, & farmers) on strategic direction"
        alt: "A non-profit uses Consider.it to do stakeholder engagement for a new strategic plan."
      }
    ]
  }

  {
    title: 'Doing something else '
    subtitle: 'that is unexpected!'
    examples: [
      {
        img: 'logos/rupaul_logo.png'
        example: 'https://rupaul.consider.it'
        img_dim: {height: 81, width: 192}        
        color: '#D600B1'
        anchor: "Fans discussing contestants"
        alt: "Fans of the show Ru Paul's Drag Race use Consider.it to evaluate contestants' performances."
      }
      # {
      #   img: 'logos/analects.jpg'
      #   example: 'https://analects-your-opinion.consider.it'
      #   img_dim: {height: 72, width: 192}        
      #   color: '#2f2923'
      #   anchor: "Classroom book discussion"
      # }
      # {
      #   img: 'logos/CIMSEC.png'
      #   example: 'https://cimsec.consider.it'
      #   img_dim: {height: 53, width: 232}        
      #   color: '#001c55'
      #   anchor: "Wargaming"
      # }            
    ]
  }

]

styles += """
  .flex-table-row {
    display: flex;
    align-items: center; 
    padding: 24px;   
    border-bottom: 1px dashed #e1e1e1;
  }

  .example_forum {
    display: none;
  }

  @media (max-width: 693px) {
    .flex-table-row {
      flex-direction: column;
      justify-content: center;
      border-bottom: none;
    }

    .flex-table-cell > div, .flex-table-cell a {
      text-align: center;
    }

    .example_forum {
      display: block;
      font-style: italic;
      margin-bottom: 12px;
    }


  }



  .flex-table-row.first {
    position: relative;
    padding: 24px 24px 36px 24px;
  }

  .flex-table-row:last-child {
    border-bottom: none;
  }

  .flex-table-cell {
    height: 100px;
    vertical-align: middle;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
  }

  @media (min-width: 375px) {
    .flex-table-cell-title {
      min-width: 366px;
    }

  }



  .flex-table-cell-title.first {
    margin-top: 56px;
  }

  .flex-table-cell-like {
    font-style: italic;
    text-align: center;
    font-size: 18px;
    padding-right: 40px;
    /* min-width: 120px; */
    flex-grow: 2;

  }

  .flex-table-cell-logo {
    min-width: 280px;
  }

  .flex-table-cell-link {

  }

  .toggle_examples {
    background-color: #{seattle_salmon};
    color: white;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 700;
    border-radius: 4px;
    border: none;
    margin-top: 8px;
    position: absolute;
    bottom: 12px;
  }

  @media (max-width: 725px) {
    .toggle_examples {
      display: none;
    }
  }

  @media (max-width: 955px) {
    .flex-table-cell-like {
      display: none;
    }
  }

  @media (max-width: 850px) {
    .flex-table-cell-link {
      display: none;
    }
  }

  @media (max-width: 450px) {
    .delightful_surprise {
      display: none;
    }
  }
  
"""


UseCases = ReactiveComponent
  displayName: 'UseCases'

  render: -> 


    get_row = (use, example, extra, idx, expanded) =>

      DIV 
        key: example.example
        className: "flex-table-row #{if !extra then 'first' else 'extra'} #{if idx % 2 then 'odd' else 'even'} #{if expanded then 'expanded' else 'collapsed'}"

        DIV 
          className: "flex-table-cell flex-table-cell-title"
          style: 
            visibility: if extra then 'hidden'

          H3 null,
            DIV 
              style: 
                fontSize: responsive_css_rule({min_size: 19, max_size: 24, min_vw: 374, max_vw: 474})
                fontWeight: 700
              use.title 

            DIV   
              style: 
                fontWeight: 400
                fontSize: responsive_css_rule({min_size: 15, max_size: 18, min_vw: 374, max_vw: 474})
              use.subtitle


          if !extra && use.examples.length > 1
            BUTTON
              className: "toggle_examples"
              onClick: =>
                @local.show_more[use.title] = !@local.show_more[use.title]
                save @local

              if @local.show_more[use.title]
                "Show fewer examples"
              else
                "Reveal more examples"


        DIV 
          className: "flex-table-cell flex-table-cell-like #{if idx % 2 then 'odd' else 'even'}"
          style: 
            visibility: if extra then 'hidden'

          'like'

        DIV 
          className: "flex-table-cell flex-table-cell-logo #{if idx % 2 then 'odd' else 'even'}"

          DIV 
            className: 'example_forum'
            "for example:"

          A 
            href: example.example
            target: '_blank'
            style: 
              fontSize: 18
              fontWeight: 700
              color: example.color 
              position: 'relative'
              top: example.adj?.top or 0
              left: example.adj?.left or 0


            IMG 
              alt: example.alt or "image for use case #{example.anchor}"
              title: example.alt
              src: asset("product_page/#{example.img}")
              style: 
                width: example.img_dim.width
                height: example.img_dim.height 
                verticalAlign: 'middle'

            SPAN 
              style: 
                fontSize: 0
                visibility: 'hidden'
              example.anchor

        DIV 
          className: "flex-table-cell flex-table-cell-link #{if idx % 2 then 'odd' else 'even'}"
          style: 
            width: responsive_css_rule({min_size: 128, max_size: 300, min_vw: 1100, max_vw: 1101})

          A 
            href: example.example
            style: 
              fontSize: 18
              fontWeight: 700
              textDecoration: 'underline'
              color: 'black' # example.color 
            target: '_blank'

            if example.anchor && WINDOW_WIDTH() > 1100
              example.anchor
            else 
              'Visit example'




    @local.show_more ?= {}

    DIV null,


      DIV
        style: 
          width: "var(--SAAS_PAGE_WIDTH)"
          margin: 'auto'


        DIV 
          style: 
            maxWidth: 720
            margin: 'auto'
            marginBottom: if WINDOW_WIDTH() > 450 then 52 else 4
            textAlign: 'center'

          H2
            className: 'light_callout'

            if WINDOW_WIDTH() > 450
              'What can Consider.it be used for?'
            else 
              'What are Consider.it\'s uses?'

          SPAN
            className: 'delightful_surprise'
            style: 
              fontSize: 18
            "We're often delightfully surprised by the ways Consider.it is put to use!"


        DIV 
          className: 'flex-table' # 'flex-table-row-based'

          for use, row in use_cases  
            forums = use.examples
            for forum, col in forums
              if col == 0 || @local.show_more[use.title]
                get_row(use, forum, col > 0, row, @local.show_more[use.title])










/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/landing_page.coffee
 **/